import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
const defLang = localStorage.getItem('defLang');
i18n
  .use(HttpApi)               // load translations via HTTP
  .use(LanguageDetector)      // detect user language
  .use(initReactI18next)      // pass i18n instance to react-i18next
  .init({
    fallbackLng: defLang ? defLang : 'en',
    supportedLngs: ['en', 'pt', 'fr'],
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });
